import api from './client';

export const fetchEarnings = async (range = 30) => {
  const res = await api.get('/wallet/earnings', { params: { range } });
  return res.data;
};

export const downloadEarningsCsv = async (range = 30) => {
  // Use axios with responseType: 'blob' so headers/auth are handled automatically.
  const res = await api.get('/wallet/earnings/export.csv', {
    params: { range },
    responseType: 'blob',
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  // Try to read filename from Content-Disposition
  const cd = res.headers['content-disposition'] || res.headers['Content-Disposition'] || '';
  const match = cd.match(/filename="?([^";]+)"?/i);
  a.download = match ? match[1] : `earnings_${range}d.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
};
